import { render, staticRenderFns } from "./tiaoifyartic.vue?vue&type=template&id=2cec9f42&scoped=true&"
import script from "./tiaoifyartic.vue?vue&type=script&lang=js&"
export * from "./tiaoifyartic.vue?vue&type=script&lang=js&"
import style0 from "./tiaoifyartic.vue?vue&type=style&index=0&id=2cec9f42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cec9f42",
  null
  
)

export default component.exports